import './Checkboxes.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
var Checkboxes = function Checkboxes(_ref) {
  var checkboxes = _ref.checkboxes,
    changeEvent = _ref.changeEvent,
    fieldError = _ref.fieldError;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  function handleChange(event) {
    changeEvent(event.target.name, event.target.checked);
  }
  function keyPressHandler(e) {
    var target = e.target;
    if (e.key === "Enter" || e.key === "NumpadEnter") {
      e.preventDefault();
      changeEvent(target.name, !target.checked);
    }
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group lr__bm-less"
  }, checkboxes.map(function (_ref2) {
    var name = _ref2.name,
      label = _ref2.label,
      value = _ref2.value,
      id = _ref2.id,
      _ref2$isRequired = _ref2.isRequired,
      isRequired = _ref2$isRequired === void 0 ? false : _ref2$isRequired,
      childrenHTML = _ref2.childrenHTML;
    return /*#__PURE__*/React.createElement("div", {
      className: "form-check",
      key: label
    }, /*#__PURE__*/React.createElement("input", {
      className: "form-check-input checkbox lr__cb",
      type: "checkbox",
      checked: value,
      name: name,
      onChange: handleChange,
      id: id,
      onKeyPress: keyPressHandler,
      title: label,
      "aria-label": label
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: id
    }, /*#__PURE__*/React.isValidElement(childrenHTML) ? childrenHTML : label, " ", isRequired ? "*" : ""));
  }), fieldError && fieldError.length ? fieldError.split('[|]').map(function (error, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "lr__error"
    }, error);
  }) : null));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStyles)
  }, children);
};
var commonStyles = "ch0w7pf";
var ltrStyles = "l86hcp6";
var rtlStyles = "r18d3ad8";
export default Checkboxes;